import { EnumTpDescontoAcrescimo } from 'model/enums/enum-tp-desconto-acrescimo';

export class AdicionarDescontoAcrescimoFormModel {
    constructor(
        public vPorcentagem: number | null = null,
        public vValorFixo: number | null = null,
        public tpCampo: EnumTpDescontoAcrescimo = 0,
    ) { }
}